import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getSite } from '../tools/fetcher';
import TestimonialSlider from './TestimonialSlider';
import { classNames } from '../tools/helpers';

export default function Testimonial({
    className,
    classNameSlider,
    innerWidth,
}) {
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    return (
        <>
            <div className={classNames('flex justify-between', className)}>
                <div
                    className={classNames(
                        'max-w-[560px] space-y-4',
                        innerWidth,
                    )}
                >
                    <p
                        className={
                            'font-bold text-xs sm:text-sm text-primary-green-100 tracking-[0.2em]'
                        }
                    >
                        {data?.testimonial?.title}
                    </p>
                    <p
                        className={
                            'font-bold text-[32px] sm:leading-[52px] sm:text-[40px] text-primary-green-101'
                        }
                    >
                        {data?.testimonial?.description}
                    </p>
                </div>
            </div>
            <div className={classNameSlider}>
                <div className={classNames('relative', innerWidth)}>
                    <TestimonialSlider />
                </div>
            </div>
        </>
    );
}
